var map = {
	"./almond.png": 99466,
	"./apples.png": 17434,
	"./apricot.png": 48124,
	"./artichoke.png": 93000,
	"./asparagus.png": 42626,
	"./avocado.png": 62224,
	"./banana.png": 81111,
	"./basil.png": 1068,
	"./batavia.png": 745,
	"./beans.png": 41958,
	"./beetroot.png": 23350,
	"./blackberry.png": 20499,
	"./blueberry.png": 63769,
	"./brazilian-nut.png": 29002,
	"./broccoli.png": 76396,
	"./cabbage.png": 46879,
	"./carrot.png": 5518,
	"./cashew-nuts.png": 85926,
	"./cauliflower.png": 2283,
	"./celery-root.png": 79638,
	"./celery.png": 51367,
	"./champignon.png": 41381,
	"./chanterelle.png": 55120,
	"./cherry-plum.png": 38000,
	"./cherry.png": 51055,
	"./chestnut.png": 17565,
	"./chickpeas.png": 16995,
	"./chicory.png": 10430,
	"./cilantro.png": 23953,
	"./coconut.png": 37967,
	"./cola.png": 25156,
	"./corn.png": 80692,
	"./cornelian-cherry.png": 84397,
	"./courgette.png": 10374,
	"./cranberry.png": 35534,
	"./cucumbers.png": 63919,
	"./daikon.png": 93257,
	"./dates.png": 47003,
	"./dill.png": 34479,
	"./dragon-fruit.png": 43705,
	"./dried-apricots.png": 63936,
	"./dried-coconut.png": 19499,
	"./dried-figs.png": 87530,
	"./dried-fruit.png": 52760,
	"./dried-mango.png": 68541,
	"./dried-pineapples.png": 61653,
	"./eggplant.png": 81997,
	"./feijoa.png": 27680,
	"./fennel.png": 23243,
	"./fig.png": 71322,
	"./frielis.png": 50500,
	"./garlic.png": 46585,
	"./ginger.png": 73838,
	"./gooseberry.png": 98694,
	"./grape.png": 18428,
	"./grapefruit.png": 89094,
	"./green-onion.png": 77169,
	"./hazelnut.png": 42273,
	"./iceberg.png": 73882,
	"./kiwi-dried.png": 85915,
	"./kiwi.png": 30346,
	"./kumquat.png": 23905,
	"./laurel.png": 11052,
	"./leaf-salad.png": 83902,
	"./leek.png": 19331,
	"./lemon.png": 86053,
	"./lemongrass.png": 97746,
	"./lettuce.png": 24914,
	"./lime.png": 32006,
	"./lingonberry.png": 11049,
	"./lolo-bionda.png": 13942,
	"./lolo-rossa.png": 9575,
	"./lychee.png": 5769,
	"./macadamia.png": 64968,
	"./mandarin.png": 28989,
	"./mango.png": 27179,
	"./mangosteen.png": 2730,
	"./medlar.png": 49961,
	"./melisserie.png": 46462,
	"./melon.png": 40060,
	"./mint.png": 41637,
	"./mustard.png": 54311,
	"./nectarine.png": 6502,
	"./onion.png": 1310,
	"./orange.png": 93557,
	"./oregano.png": 61478,
	"./papaya-pomaya.png": 54475,
	"./parsley.png": 37625,
	"./passion-fruit.png": 4643,
	"./patisson.png": 75940,
	"./peach.png": 56517,
	"./peanut.png": 72741,
	"./pear.png": 86109,
	"./pecan.png": 67508,
	"./pepper.png": 58847,
	"./persimmon.png": 96095,
	"./physalis.png": 15737,
	"./pine-nut.png": 68702,
	"./pineapple.png": 55156,
	"./pistachios.png": 37209,
	"./plum.png": 22019,
	"./pomegranate.png": 97770,
	"./pomelo.png": 69923,
	"./potato.png": 9740,
	"./prunes.png": 65142,
	"./pumpkin.png": 72320,
	"./quince.png": 78129,
	"./radicio.png": 32778,
	"./radish.png": 89670,
	"./raisin.png": 42012,
	"./rambutan.png": 47493,
	"./ramson.png": 55348,
	"./raspberry.png": 46075,
	"./razmarin.png": 34813,
	"./red-radish.png": 93352,
	"./romano.png": 94000,
	"./root-horseradish.png": 9135,
	"./rosehip.png": 5866,
	"./rucolla.png": 90439,
	"./sage.png": 13441,
	"./seeds.png": 10247,
	"./sesame.png": 51826,
	"./sorrel.png": 83544,
	"./strawberry.png": 60673,
	"./sweet-cherry.png": 25069,
	"./sweet-potato.png": 59617,
	"./sweetie.png": 71927,
	"./tarragon.png": 65232,
	"./thyme.png": 40266,
	"./tomato.png": 29637,
	"./turnip.png": 67896,
	"./walnut.png": 83138,
	"./watercress.png": 82439,
	"./watermelon.png": 68315,
	"./whortleberry.png": 54748,
	"./wild-strawberry.png": 49266,
	"./zucchini.png": 17291,
	"./сompote-mixture.png": 68392,
	"./сranberries-dried.png": 37702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20666;